// src/components/DocumentHead.js
import { useEffect } from 'react';
import { useCompanySettings } from '../hooks/useCompanySettings';

const DocumentHead = () => {
    const { settings, loading } = useCompanySettings();

    useEffect(() => {
        if (!loading && settings) {
            // Update document title
            const title = settings.name ? `${settings.name}` : 'B2B Management System';
            document.title = title;

            // Update favicon if icon is available
            if (settings.icon) {
                // Remove existing favicon links
                const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
                existingFavicons.forEach(link => link.remove());

                // Add new favicon
                const favicon = document.createElement('link');
                favicon.rel = 'icon';
                favicon.type = 'image/x-icon';
                favicon.href = settings.icon;
                document.head.appendChild(favicon);

                // Add apple touch icon
                const appleTouchIcon = document.createElement('link');
                appleTouchIcon.rel = 'apple-touch-icon';
                appleTouchIcon.href = settings.icon;
                document.head.appendChild(appleTouchIcon);

                // Add various sized icons for different devices
                const sizes = ['16x16', '32x32', '96x96', '192x192'];
                sizes.forEach(size => {
                    const sizedIcon = document.createElement('link');
                    sizedIcon.rel = 'icon';
                    sizedIcon.type = 'image/png';
                    sizedIcon.sizes = size;
                    sizedIcon.href = settings.icon;
                    document.head.appendChild(sizedIcon);
                });
            }

            // Update meta description
            const description = `${settings.name || 'B2B Management System'} - Professional business management platform`;
            let metaDescription = document.querySelector('meta[name="description"]');
            if (!metaDescription) {
                metaDescription = document.createElement('meta');
                metaDescription.name = 'description';
                document.head.appendChild(metaDescription);
            }
            metaDescription.content = description;

            // Update Open Graph meta tags for social sharing
            const ogTitle = document.querySelector('meta[property="og:title"]') || document.createElement('meta');
            ogTitle.setAttribute('property', 'og:title');
            ogTitle.content = settings.name || 'B2B Management System';
            if (!document.querySelector('meta[property="og:title"]')) {
                document.head.appendChild(ogTitle);
            }

            const ogDescription = document.querySelector('meta[property="og:description"]') || document.createElement('meta');
            ogDescription.setAttribute('property', 'og:description');
            ogDescription.content = description;
            if (!document.querySelector('meta[property="og:description"]')) {
                document.head.appendChild(ogDescription);
            }

            if (settings.logo) {
                const ogImage = document.querySelector('meta[property="og:image"]') || document.createElement('meta');
                ogImage.setAttribute('property', 'og:image');
                ogImage.content = settings.logo;
                if (!document.querySelector('meta[property="og:image"]')) {
                    document.head.appendChild(ogImage);
                }
            }
        }
    }, [settings, loading]);

    // This component doesn't render anything
    return null;
};

export default DocumentHead;